import React from "react";

const DropboxFolderBrowser = ({
  showFolderBrowser,
  setShowFolderBrowser,
  selectedFile,
  currentPath,
  setCurrentPath,
  dropboxFolders,
  loadingFolders,
  fetchDropboxFolders,
  setSelectedFolder,
  handleConfirmUpload,
}) => {
  if (!showFolderBrowser) return null;

  const handleFolderClick = (folder) => {
    const path = folder.path_display || folder.path_lower || folder.name || "";
    setCurrentPath(path);
    setSelectedFolder(path);
    fetchDropboxFolders(path);
  };

  const handleConfirm = () => {
    handleConfirmUpload();
  };

  const handleCancel = () => {
    setShowFolderBrowser(false);
    setCurrentPath("");
    setSelectedFolder("");
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70]">
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full max-h-[80vh] flex flex-col p-4">
        <h3 className="text-lg font-semibold mb-2">Choose Dropbox folder</h3>
        {selectedFile && (
          <p className="text-sm text-gray-600 mb-2 truncate">
            File: {selectedFile.name}
          </p>
        )}
        <div className="border rounded overflow-y-auto flex-1 min-h-[200px] p-2">
          {loadingFolders ? (
            <p className="text-gray-500">Loading folders...</p>
          ) : dropboxFolders.length === 0 && !currentPath ? (
            <p className="text-gray-500">No folders found.</p>
          ) : (
            <ul className="space-y-1">
              {currentPath && (
                <li>
                  <button
                    type="button"
                    onClick={() => {
                      const parent = currentPath.split("/").slice(0, -1).join("/");
                      setCurrentPath(parent);
                      setSelectedFolder(parent);
                      fetchDropboxFolders(parent);
                    }}
                    className="text-blue-600 hover:underline text-left w-full py-1"
                  >
                    .. (Up)
                  </button>
                </li>
              )}
              {dropboxFolders.map((folder) => (
                <li key={folder.id || folder.path_lower || folder.name}>
                  <button
                    type="button"
                    onClick={() => handleFolderClick(folder)}
                    className="text-left w-full py-2 px-2 rounded hover:bg-gray-100 flex items-center gap-2"
                  >
                    <span className="text-gray-600">📁</span>
                    {folder.name}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="flex gap-2 mt-4">
          <button
            type="button"
            onClick={handleConfirm}
            className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
          >
            Upload here
          </button>
          <button
            type="button"
            onClick={handleCancel}
            className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DropboxFolderBrowser;
